import React from "react";
import dynamic from "next/dynamic";
import TextInfo, { TEXT_DISPLAY } from "@gc-npm/components.text";
import IconGlyph from "@gc-npm/components.icon-glyph";

const Image = dynamic(() => import("@/component/c-image"));
const Price = dynamic(() => import("@gc-npm/components.price"));
const Label = dynamic(() => import("@gc-npm/components.label"));
const TextList = dynamic(() => import("@/component/text-list"));

const CardTemplate = (cardProps) => {
  if (!cardProps) {
    return null;
  }

  const headerIcon = cardProps["Glyph-1"];
  const backgroundGlyph = cardProps["Glyph-2"];
  const img = cardProps["Image-2"];
  const imgThree = cardProps["Image-3"];
  const labelZero = cardProps["Label-0"];
  const label = cardProps["Label-1"];
  const labelTwo = cardProps["Label-2"];
  const headerPretitle = cardProps["Text-1"];
  const headerTitle = cardProps["Text-2"];
  const headerSuperTitle = cardProps["Text-6"];
  const headerPosTitle = cardProps["Text-3"];
  const price = cardProps["Price-2"];
  const priceTachado = cardProps["Price-1"];
  const prevPrice = cardProps["Text-4"];
  const postPrice = cardProps["Text-5"];
  const textList = cardProps["Characteristics-1"];
  const layout = cardProps.layout;
  const imageClassName = cardProps?.imageClassName || "";
  const hash = cardProps?.imageClassName || 'card-template';



  const showPrice =
    (price && price.amount === 0 && true) ||
    (price && price.amount) ||
    (prevPrice && prevPrice.text) ||
    (postPrice && postPrice.text);

  let colorPrice = price?.color || "GREY_700";
  if (layout === "dispo-product") {
    colorPrice = priceTachado?.amount != 0 ? "red_dark" : "GREY_700";
  }

  return (
    <>
      {img && img.src && (
        <div className={`card-container--image ${imageClassName}`}>
          <Image
            hash={hash}
            {...img}
            fill
            objectFit={img?.objectFit ? img.objectFit : "contain"}
            cydata={`Card Image-2 ${img.alt}`}
          />
        </div>
      )}
      <div className="card-container--info">
        {(headerIcon ||
          label ||
          headerPretitle ||
          headerSuperTitle ||
          headerPosTitle ||
          showPrice) && (
          <div className="card-header">
            {headerIcon && headerIcon.id && (
              <div className="card-header--icon" data-cy="Card Glyph-1">
                <IconGlyph {...headerIcon} />
              </div>
            )}

            {headerPretitle && headerPretitle.text && (
              <TextInfo
                className="card-header--pretitle"
                {...headerPretitle}
                cydata="Card Text-1"
              />
            )}

            {headerTitle && headerTitle.text && (
              <TextInfo
                className="card-header--title"
                {...headerTitle}
                cydata="Card Text-2"
              />
            )}
            {headerSuperTitle && headerSuperTitle.text && (
              <TextInfo
                className="card-header--supertitle"
                {...headerSuperTitle}
                cydata="Card Text-6"
              />
            )}

            {headerPosTitle && headerPosTitle.text && (
              <TextInfo
                className="card-header--subtitle"
                {...headerPosTitle}
                cydata="Card Text-3"
              />
            )}
          </div>
        )}

        {showPrice && (
          <div className="card-content">
            {labelTwo && labelTwo.label && (
              <div className="card-container--label card-container--label-two">
                <Label {...labelTwo} cydata="Card Label-2" />
              </div>
            )}

            <div className="card-content--price">
              {prevPrice && prevPrice.text && (
                <TextInfo
                  className="price--pre-price"
                  {...prevPrice}
                  cydata="Card Text-4"
                />
              )}
              {priceTachado &&
                priceTachado.amount &&
                priceTachado.amount != 0 && (
                  <Price
                    price={priceTachado.amount}
                    currency={priceTachado.unity}
                    quote={priceTachado.frequency}
                    cydata="Card Price-1"
                    {...priceTachado}
                  />
                )}
              {price && (price.amount || price.amount == 0) && (
                <Price
                  price={price.amount}
                  currency={price.unity}
                  quote={price.frequency}
                  cydata="Card Price-2"
                  {...price}
                  color={colorPrice}
                />
              )}
              {postPrice && postPrice.text && (
                <TextInfo
                  className="price--post-price"
                  {...postPrice}
                  cydata="Card Text-5"
                />
              )}
            </div>
          </div>
        )}
      </div>
      {textList && Object.entries(textList).length > 0 && (
        <div className="card-text-list">
          <TextList items={textList} />
        </div>
      )}

      {imgThree && imgThree.src && (
        <div className="card-container--image-three">
          <Image
            hash={hash}
            {...imgThree}
            objectFit="contain"
            fill
            objectPosition="center"
            cydata={`Card Image-3 ${imgThree.alt}`}
          />
        </div>
      )}
      {backgroundGlyph && backgroundGlyph.src && (
        <div className="card-glyph">
          <object
            type="image/svg+xml"
            data={backgroundGlyph.src}
            title={
              backgroundGlyph.alt ? backgroundGlyph.alt : "Ofertas Movistar"
            }
          ></object>
        </div>
      )}
    </>
  );
};

export default CardTemplate;
